import { render, staticRenderFns } from "./CardBecomeHost.vue?vue&type=template&id=ba361a3c&scoped=true&"
import script from "./CardBecomeHost.vue?vue&type=script&lang=js&"
export * from "./CardBecomeHost.vue?vue&type=script&lang=js&"
import style0 from "./CardBecomeHost.vue?vue&type=style&index=0&id=ba361a3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba361a3c",
  null
  
)

export default component.exports